import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { VendorData, cabData } from 'src/app/Pages/sosalert/alert.data';
import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { KDTreeService } from 'src/app/Services/kdtree.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { MapService } from 'src/app/Services/map.service';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';


declare const $;
const call_Icon = `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29" xml:space="preserve" width="288" height="288"><path d="M20.914 17.743l-2.091 1.178a1.319 1.319 0 0 1-1.58-.217l-6.979-6.979a1.32 1.32 0 0 1-.217-1.58l1.178-2.091a1.978 1.978 0 0 0-.325-2.37L7.766 2.55a1.978 1.978 0 0 0-2.798 0L3.545 3.972a5.276 5.276 0 0 0-.793 6.446l.714 1.19a41.36 41.36 0 0 0 14.946 14.631l.141.081c2.102 1.201 4.699.851 6.382-.831l1.486-1.486a1.978 1.978 0 0 0 0-2.798l-3.136-3.136a1.978 1.978 0 0 0-2.371-.326z" fill="#6364af" class="color000 svgShape"/><path fill="none" stroke="#377918" stroke-miterlimit="10" stroke-width="2" d="M22.018 6.982l-6 6M18.018 6.482h4.5v4.5" class="colorStroke000 svgStroke"/></svg>`;


@Component({
  selector: 'g10-sos-information',
  templateUrl: './sos-information.component.html',
  styleUrls: ['./sos-information.component.css']
})
export class SosInformationComponent implements OnInit {

  @Input() popup = true;
  @Input() modalTitle = 'Sos Information';
  @Input() sosType;
  @Input() sosData;
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  public formSubmitted: boolean = false;
  public enableActionForm: boolean = false;
  public objKeys = Object.keys;

  audioisShow = false;
  isShowEmployee = false;
  isShowVehicle = false;

  public isShowClickToCall: boolean = false;
  public callConnectingDot: boolean = false;
  public connectedCallList: any = {}; // Employee or Driver IDs

  date = new Date();

  EmployeeData: any = {};
  public vehicleInfo: any = {};
  driverData: any = [];
  singleDriver: any = {}; // Temporary driver info

  vendorData = VendorData;
  public loggedInInfo: any;
  public vendorDetails: any = {};

  public driverLicence: any;
  public fileName: string;

  public locationRegExp = `,`;
  public locationReplaceStr = `, `;
  public defaultImageUrl: string = `../../../../../../../assets/images/home/employee.png`;

  constructor(
    private map: MapService,
    private loader: LoaderService,
    private kdTree: KDTreeService,
    private api: ApiService,
    private store: StorageService,
    private file: FileUploadService,
    private swal: SweetAlert,
    private router: Router,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private s3AudioService: S3BudgetService,
  ) {
    iconRegistry.addSvgIconLiteral('callIcon', sanitizer.bypassSecurityTrustHtml(call_Icon));
  }

  ngOnInit(): void {
    this.sosDataSetup(this.sosData);
  }

  closePopup() {
    this.closeEvent.emit(true);
  }

  connectCall(receiver, id) {
    if (this.loggedInInfo && this.loggedInInfo.userID && !(this.connectedCallList && this.connectedCallList[receiver] && this.connectedCallList[receiver][id])) {

      let obj = {
        makecall: [`${this.loggedInInfo.userID}#$O`],
      };

      switch (receiver) {
        case 'Driver':
          obj.makecall[1] = `${id}#$D`;
          break;
        case 'Employee':
          obj.makecall[1] = `${id}#$E`;
          break;
        case 'Vendor':
          obj.makecall[1] = `${id}#$V`;
          break;
        default: break;
      }
      this.api.sosClickToCall(obj).then((res: any) => {
        if (res.status == 'success') {

          if (this.connectedCallList[receiver] == undefined) this.connectedCallList[receiver] = {};
          if (this.connectedCallList[receiver][id] == undefined) this.connectedCallList[receiver][id] = {};

          this.connectedCallList[receiver][id] = true;

          setTimeout(() => {
            this.connectedCallList[receiver][id] = false;
          }, 60000)

          // this.swal.swalFunction(res.status, res.status, res.message, 2000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }

      }).catch((err) => {
        console.log(err);
      });

    }

  }

  playAudioFile() {
    if (this.sosData['sos'] && this.sosData['sos']['sosAudio'] && this.sosData['sos']['sosAudio'].length > 0) {
      this.audioisShow = !this.audioisShow;
      setTimeout(() => { this.playMultiAudio(this.sosData['sos']['sosAudio']); }, 1000);
    }
  }

  fetchResults(url) {
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        console.log("hi", myJson);
        // resolve(myJson);
      });
  }

  getVehicleRegNo(vehId) {
    let keys = Object.keys(this.vehicleInfo);
    let regNo;
    keys.filter((key) => { if (this.vehicleInfo[key]['vehicleID'] == vehId) regNo = key; });
    return regNo;
  }


  async downloadDriverLicence(driver) {

    try {

      // fetch(driver.licence,
      //   { method: "HEAD" }
      // ).then((res) => {
      //   if (res.ok ) {
      //     this.swal.swalFunction('success', "Success", "Please check your downloads", 3000);
      //   } else {
      //     this.swal.swalFunction('error', "Warning", "Record Not Found", 3000);
      //   }
      // });



      this.fileName = `${driver.name.replaceAll(' ', '_')}-licence.jpg`;
      this.driverLicence = await this.file.urlHandleBase64(driver.licence)
    

      console.log(driver.licence);
      setTimeout(() => {
        console.log(document.getElementById('downloadLicence'));
        document.getElementById('downloadLicence').click();

      }, 200);
    } catch (e) {

      
    }

  }

  checkTimestamp(time) {
    let result: boolean = false;
    let less1Hr = new Date().setHours(new Date().getHours() - 1);
    let timestamp = new Date(less1Hr).getTime();
    if (time > timestamp) result = true;
    return result

  }

  async sosDataSetup(val) {
    console.log(val);
    // this.isShowClickToCall = this.checkTimestamp(val.gpsTS);
    // this.audioisShow = false;
    // if (val.isMobile) {
    //   this.isShowVehicle = false;
    //   this.isShowEmployee = true;
    // }
    // else if (val.isMobile == undefined || !val.isMobile) {
    //   this.isShowEmployee = false;
    //   this.isShowVehicle = true;
    // }
  }

  playMultiAudio(audio) {
    let audioEl: any = document.getElementById('audioSrc');
    let index = 1;
    audioEl.onended = function () {
      if (index < audio.length) {
        // audioEl.src =  this.sanitizer.bypassSecurityTrustUrl(audio[index]);
        audioEl.src = audio[index];
        audioEl.play();
        index++;
      }
    };
  }

  close() {
    this.audioisShow = false;
  }

}
